export let BASE_URL;
export let STAGING_URL;
export let STAGING_UAT_URL;
export let PRODUCTION_URL;
export let DEV_url;

export let LOCAL_URL;

BASE_URL = "https://devctrsapi.azurewebsites.net";
LOCAL_URL = "https://localhost";
STAGING_URL = "http://dev-api-ctrs.us-east-1.elasticbeanstalk.com";
STAGING_UAT_URL = "https://uat.api.eclinrecruit.ai";
DEV_url = "https://dev.api.eclinrecruit.ai";
const apiUrl = process.env.REACT_APP_API_URL;

export const ENDPOINTS = {
  PATIENT: {
    PATIENT_LIST: `${apiUrl}/api/patient/get-all-patients`,
    ADD_PATIENT: `${apiUrl}/api/patient/add-patient`,
    SORT_ASC: `${apiUrl}/api/patient/get-all-patients?Sorts=createdAt`,
    SORT_DESC: `${apiUrl}/api/patient/get-all-patients?Sorts=-createdAt`,
    DELETE_PATIENT: `${apiUrl}/api/patient/delete-patient`,
    GET_PATIENT_BY_ID: `${apiUrl}/api/patient/get-patient-by-id`,
    EDIT_PATIENT: `${apiUrl}/api/patient/update-patient`,
    BULK_UPLOAD: `${apiUrl}/api/patient/bulk-upload-patient`,
    BULK_UPLOAD_LOGS: `${apiUrl}/api/patient/bulkupload-patient-logs`,
    BULK_UPLOAD_LOGS_DETAILS: `${apiUrl}/api/patient/bulkupload-patient-logs-details`,
    GET_STATES: `${apiUrl}/api/patient/get-all-states`,
    GET_STATES_CITY: `${apiUrl}/api/patient/get-city-by-state`,
  },
  CLINIC: {
    CLINIC_INFO: `${apiUrl}/api/clinic/get-all-clinicinfo`,
    EDIT_CLINIC: `${apiUrl}/api/clinic/update-clinic-info`,
    TIMEZONE: `${apiUrl}/api/clinic/get-timezone`,
    ADD_CLINIC: `${apiUrl}/api/clinic/add-clinic-info`,
    DISEASE: `${apiUrl}/api/clinic/get-disease-by-clinicinfoid`,
    GET_CLINIC_BY_ID: `${apiUrl}/api/clinic/get-clinicinfo-by-id`,
  },
  TRIALS: {
    GET_ALL_TRIAL: `${apiUrl}/api/trial/get-all-trials`,
    TRIAL_STATUS: `${apiUrl}/api/trial/get-patient-by-trial`,
    TRIAL_STATUS_WITH_QUERY: `${apiUrl}/api/trial/get-patient-by-trial-pagination`,
    TRIAL_STATUS_QUEUED_WITH_QUERY: `${apiUrl}/api/trial/get-queue-patient-by-trial`,
    TRIAL_STATUS_SKIPPED_WITH_QUERY: `${apiUrl}/api/trial/get-skipped-patient-by-trial`,
    GET_EXPORT_PATIENT_TRIAL_STATUS: `${apiUrl}/api/trial/get-export-patient-trial-status`,
    SORT_ASC: `${apiUrl}/api/trial/get-patient-by-trial?Sorts=createdAt`,
    SORT_DESC: `${apiUrl}/api/trial/get-patient-by-trial?Sorts=-createdAt`,
    GET_TRIAL_BY_ID: `${apiUrl}/api/trial/get-trial-by-id`,
    GET_TRIAL_NAME: `${apiUrl}/api/trial/get-all-trials-name`,
    ACTIVE: `${apiUrl}/api/trial/reactive-trial?trialID=`,
    DEACTIVE: `${apiUrl}/api/trial/delete-trial?trialID=`,
    DELETE_TRIAL_STATUS: `${apiUrl}/api/trial/delete-patient-from-trial`,
    ASSIGN_RECRUITER: `${apiUrl}/api/trial/assign-patient-to-recruiter`,
    CHANGE_PATIENT_STATUS: `${apiUrl}/api/conversation/update-patient-qualified-by-patienttrialjunc-id`,
    GET_ALL_TRIAL_STATUS: `${apiUrl}/api/trialstatus/get-all-trial-status`,
    REROUTE: `${apiUrl}/api/trial/reroute-patient-to-trial`,
    UPLOAD_IMAGE: `${apiUrl}/api/trial/upload-trial-introduction-image`,
    TRIAL_STATUS_COUNT: `${apiUrl}/api/trial/get-trial-count`,
    GET_PATIENT_SCREENING: `${apiUrl}/api/trial/get-patient-screening-data`,
    UPDATE_PATIENT_SCREENING: `${apiUrl}/api/trial/update-patient-screening-data`,
    GET_ECLINPRO_LOCATIONS: `${apiUrl}/api/trial/get-eclinpro-locations`
  },
  RECRUITERS: {
    GET_RECTRUITERS: `${apiUrl}/api/recruiter/get-all-recruiters`,
    EDIT_RECRUITERS: `${apiUrl}/api/recruiter/update-recruiter`,
    DELETE_RECRUITERS: `${apiUrl}/api/recruiter/delete-recruiter`,
    ADD_RECRUITERS: `${apiUrl}/api/recruiter/add-recruiter`,
    SORT_ASC: `${apiUrl}/api/recruiter/get-all-recruiters?Sorts=createdAt`,
    SORT_DESC: `${apiUrl}/api/recruiter/get-all-recruiters?Sorts=-createdAt`,
    RECRUITER_BY_ID: `${apiUrl}/api/recruiter/get-recruiter-by-id`,
    GET_ALL_TRIAL: `${apiUrl}/api/trial/get-all-trials`,
    TRIAL_STATUS: `${apiUrl}/api/trial/get-patient-by-trial`,
    SORT_ASC: `${apiUrl}/api/trial/get-patient-by-trial?Sorts=createdAt`,
    SORT_DESC: `${apiUrl}/api/trial/get-patient-by-trial?Sorts=-createdAt`,
    GET_TRIAL_BY_ID: `${apiUrl}/api/trial/get-trial-by-id`,
    GET_TRIAL_NAME: `${apiUrl}/api/trial/get-all-trials-name`,
    ACTIVE: `${apiUrl}/api/trial/reactive-trial?trialID=`,
    DEACTIVE: `${apiUrl}/api/trial/delete-trial?trialID=`,
    DELETE_TRIAL_STATUS: `${apiUrl}/api/trial/delete-patient-from-trial`,
    ASSIGN_RECRUITER: `${apiUrl}/api/trial/assign-patient-to-recruiter`,
    CHANGE_PATIENT_STATUS: `${apiUrl}/api/conversation/update-patient-qualified-by-patienttrialjunc-id`,
    GET_ALL_TRIAL_STATUS: `${apiUrl}/api/trialstatus/get-all-trial-status`,
    REROUTE: `${apiUrl}/api/trial/reroute-patient-to-trial`,
  },
  RECRUITERS: {
    GET_RECTRUITERS: `${apiUrl}/api/recruiter/get-all-recruiters`,
    EDIT_RECRUITERS: `${apiUrl}/api/recruiter/update-recruiter`,
    DELETE_RECRUITERS: `${apiUrl}/api/recruiter/delete-recruiter`,
    ADD_RECRUITERS: `${apiUrl}/api/recruiter/add-recruiter`,
    SORT_ASC: `${apiUrl}/api/recruiter/get-all-recruiters?Sorts=createdAt`,
    SORT_DESC: `${apiUrl}/api/recruiter/get-all-recruiters?Sorts=-createdAt`,
    RECRUITER_BY_ID: `${apiUrl}/api/recruiter/get-recruiter-by-id`,
    REACTIVE: `${apiUrl}/api/recruiter/reactive-recruiter`,
    RECRUITER_EMAIL_VALIDATION: `${apiUrl}/api/recruiter/validate-recruiter-email-domain`,
  },
  MICROSOFTSSO: {
    LOGIN: `${apiUrl}/api/account/get-microsoft-sso-url`,
    CODE_URL: `${apiUrl}/api/account/microsoft-sso`,
  },
  AUTH: {
    LOGIN: `${apiUrl}/api/User/login`,
    REFRESH_TOKEN: `${apiUrl}/api/User/refresh-access-token`,
  },
  USER: {
    PROFILE: `${apiUrl}/api/user/get-user-profile`,
    PROFILE_UPDATE: `${apiUrl}/api/user/user-profile`,
  },
  WORKFLOW: {
    ADD_TRIAL: `${apiUrl}/api/trial/add-trial`,
    UPDATE_TRIAL: `${apiUrl}/api/trial/update-trial`,
    GET_KNOWLEDGE_BASE_FILES: `${apiUrl}/api/trial/get-knowledge-base-files-by-trialid`,
    DELETE_KNOWLEDGE_BASE_FILE: `${apiUrl}/api/trial/delete-knowledge-base-files-by-trialid`,
    UPLOAD_KNOWLEDGE_BASE: `${apiUrl}/api/trial/upload-knowledgebase`,
  },
  CONVERSATION: {
    GET_CONVERSATION_BY_TRIAL_ID: `${apiUrl}/api/conversation/get-patient-conversation-by-patienttrialjunc-id`,
    SEND_MESSAGE: `${apiUrl}/api/conversation/outbound-sms`,
    ADD_NOTE: `${apiUrl}/api/conversation/create-note-by-patienttrialjunc-id`,
    GET_ALL_CONVERSATION: `${apiUrl}/api/conversation/get-conversationlist-by-userid`,
    GET_UPDATED_CONVERSATION: `${apiUrl}/api/conversation/get-update-unread-by-patienttrialjuncid`,
    GET_ALL_CONVERSATION: `${apiUrl}/api/conversation/get-conversationlist-by-userid`,
    UPDATE_PATIENT_CONVERSATION_CONTROL: `${apiUrl}/api/conversation/update-patient-conversation-control`,
    CREATE_EVENT: `${apiUrl}/api/callSchedule/calendar-event-by-recruiter`,
    CALL_LOGS: `${apiUrl}/api/twilioVoice/call-logs/`,

    GET_NOTES: `${apiUrl}/api/conversation/get-notes`,
    AI_AGENTS_CALL_LOGS: `${apiUrl}/api/VoiceAgent/get-aicall-recordingurl-transcript-by-patienttrialjuncid`,
    AI_AGENTS_CALL_SIGN_URL: `${apiUrl}/api/VoiceAgent/get-aicallrecording-transcript-voiceAgentCallId`,
    CALENDAR_MARK_AS_COMPLETED: `${apiUrl}/api/callSchedule/calendar-mark-as-completed`,
},
  PASSWORD: {
    FORGOT_PASSWORD: `${apiUrl}/api/user/forgot-password`,
    RESET_PASSWORD: `${apiUrl}/api/user/reset-password`,
    VERIFY_RESET_TOKEN: `${apiUrl}/api/user/verify-password-refresh-token`,
  },
  DASHBOARD: {
    GET_COUNT: `${apiUrl}/api/dashboard/get-dashboard-totals`,
    FUNNEL_ANALYTICS: `${apiUrl}/api/dashboard/get-patient-funnel-analytics`,
    STUDY_ANALYTICS: `${apiUrl}/api/dashboard/get-action-required-by-study`,
    CALL_VOLUME_BY_STUDY: `${apiUrl}/api/dashboard/get-aicall-volume-by-study`,
    CALL_OUTCOME_BY_STUDY: `${apiUrl}/api/dashboard/get-aicall-outcomes-by-study`,
  },
  LOCATION: {
    GET_COUNTRY: `${apiUrl}/api/Location/get-all-country-states`,
  },
  CALENDAR: {
    GET_EVENTS: `${apiUrl}/api/callSchedule/get-calendar-event`,
    CANCEL_EVENT: `${apiUrl}/api/callSchedule/update-calendar-event`,
    MICROSOFT_CALENDAR_CONNECT: `${apiUrl}/api/callSchedule/get-access-token`,
    MICROSOFT_EXIST: `${apiUrl}/api/callSchedule/calendar-integration-exist`,
    DISCONNECT_MICROSOFT_ACCOUNT: `${apiUrl}/api/callSchedule/calendar-delete-integration`,
    MICROSOFT_CALENDAR_SLOTS: `${apiUrl}/api/callSchedule/calendar-slot-starttime-by-recruiter?recruiterID=`,
    GET_CALENDER_EVENTS_COUNT: `${apiUrl}/api/callSchedule/get-calendar-event-count`,
  },
  FBINTEGRATION: {
    GET_FB_INTEGRATION: `${apiUrl}/api/metaAds/meta-integration-exist`,
    META_LOGIN: `${apiUrl}/api/metaAds/meta-integration-login-url`,
    FETCH_META_ADS_DATA: `${apiUrl}/api/metaAds/meta-integration-login-callback`,
    POST_META_ACCOUNT_SELECTION: `${apiUrl}/api/metaAds/meta-account-selection`,
    DELETE_META_EXIST: `${apiUrl}/api/metaAds/meta-delete-integration`,
    GET_UNASSIGNED_METAADFORM: `${apiUrl}/api/metaAds/get-unassigned-metaadform`,
    LINK_METAADFORM_TRIAL: `${apiUrl}/api/metaAds/link-metaadform-trial`,
    GET_METAADS_BY_TRIAL_ID: `${apiUrl}/api/metaAds/get-trial-adform-junc-list`,
    DELINK: `${apiUrl}/api/metaAds/delink-metaadform-trial`,
  },
  TWILIO_CALL: {
    TWILIO_TOKEN: `${apiUrl}/api/twilioVoice/get-twilio-token`,
  },
  DOCUSIGN: {
    SEND_DOCUMENT: `${apiUrl}/api/docuSign/sent-envelope`,
  },
  NOTIFICATION: {
    MARK_AS_READ: `${apiUrl}/api/Notifications/mark-as-read?notificationId`,
    CONNECTION: `${apiUrl}/notificationsHub?userId`,
    GET_ALL_NOTIFICATIONS: `${apiUrl}/api/Notifications/get-all-Notifications`,
    UNREAD_COUNT: `${apiUrl}/api/Notifications/unread-count`
  },
  ECLINPRO: {
    GET_ALL_ECLINPRO_TRIALS: `${apiUrl}/api/trial/get-all-eclinpro-trials`,
    LINK_ECLINPRO_TRIAL: `${apiUrl}/api/trial/link-eclinpro-trial`,
    GET_ECLINPRO_CONNECTED_TRIAL: `${apiUrl}/api/trial/get-eclinpro-connected-trial`,
    DELINK_ECLINPRO_TRIAL: `${apiUrl}/api/trial/delink-eclinpro-trial`,
  }

};
